@if (media) {
  <picture>
    @if (!isLightboxMedia) {
      @for (source of media.formats; track source.url) {
        <source [srcset]="source.url" [media]="source.query" />
      }
      <img [src]="media.original.url" [alt]="media.title" (error)="imageError.emit($event)" draggable="false" />
    } @else {
      @for (source of media.lightboxFormats; track source.url) {
        <source [srcset]="source.url" [media]="source.query" />
      }
      <img [src]="media.original.url" [alt]="media.title" (error)="imageError.emit($event)" draggable="false" />
    }
  </picture>
}
